import { render, staticRenderFns } from "./Fichero_Listado_Completo.vue?vue&type=template&id=28e7f6c4&scoped=true"
import script from "./Fichero_Listado_Completo.vue?vue&type=script&lang=js"
export * from "./Fichero_Listado_Completo.vue?vue&type=script&lang=js"
import style0 from "./Fichero_Listado_Completo.vue?vue&type=style&index=0&id=28e7f6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7f6c4",
  null
  
)

export default component.exports